import { NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, Validators } from "@angular/forms";
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { provideNgxMask } from 'ngx-mask';
import { OrdemService } from 'src/app/core/apis/orchestrador/api/api';
import { Ordem } from 'src/app/core/apis/orchestrador/model/ordem';
import { Globals } from 'src/app/core/helpers/globals';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';
import { CpfCnpjService } from 'src/app/core/service/cpf-cnpj.service';
import { AtualizarAcaoFormComponent } from './formulario/atualizar-acao-form/atualizar-acao-form.component';
import { IncluirAcaoFormComponent } from './formulario/incluir-acao-form/incluir-acao-form.component';
import { NroProcessoInputComponent } from 'src/app/shared/components/nro-processo-input/nro-processo-input.component';


@Component({
  selector: 'app-inclusao-acao',
  templateUrl: './inclusao-acao.component.html',
  styleUrls: ['./inclusao-acao.component.css'],
  standalone: true,
  providers: [provideNgxMask()],
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    NgIf,
    MatButtonModule,
    IncluirAcaoFormComponent,
    AtualizarAcaoFormComponent,
    NroProcessoInputComponent
  ]
})
export class InclusaoAcaoComponent implements OnInit {

  @Input() tokenIam: string;

  usuario;
  tpUsuario;
  form;
  ordem: Ordem;
  consultaAcaoRealizada: boolean = false;
  existeAcao: boolean = false;

  constructor(
    private ordemService: OrdemService,
    private globals: Globals,
    public dialog: MatDialog,
    public cpfCnpjService: CpfCnpjService,
    private router: Router,
    fb: UntypedFormBuilder) {
    this.form = fb.group({
      nroProcesso: [""]
    });
  }

  ngOnInit() {
    this.usuario = JSON.parse(sessionStorage.getItem('usuario'));
  }

  public buscarOrdem(): void {
    this.globals.addToLoading("cadastrar-ordem");
    this.ordemService.findByNroProcesso(this.nroProcesso.value, ["ACAO"], this.tokenIam).subscribe({
      next: (data) => {
        this.ordem = data.body;
        if (this.ordem.tpOrdem !== "ACAO") {
          this.nroProcesso.disable();
          this.consultaAcaoRealizada = true;
          this.globals.subtractFromLoading();
        } else if (this.ordem.status == "EAT") {
          this.globals.subtractFromLoading();
          this.showOrdemEmAtendimentoDialog();
        } else {
          this.nroProcesso.disable();
          this.existeAcao = true;
          this.consultaAcaoRealizada = true;
          this.globals.subtractFromLoading();
          this.openAtualizarOrdemDialog();
        }
      },
      error: (error) => {
        let errorList = error.error.Erros;
        this.nroProcesso.disable();
        this.consultaAcaoRealizada = true;
        this.globals.subtractFromLoading();

        let finalMessage = error?.error?.Erros?.[0]?.message;

        switch(true) {
          case(error.status == 400):
            this.globals.showSnackBar(finalMessage || "Requisição inválida, verifique os dados e tente novamente por favor.");
          break;

          case(error.status == 403):
            this.globals.showSnackBar(finalMessage || "Você não possui permissão para executar esta ação.");
          break;

          case(error.status == 404):
            // esperado
            this.nroProcesso.disable();
          break;

          case(error.status == 422):
            this.globals.showSnackBar(finalMessage || "Sua requisição contem campos inválidos, por favor verifique e tente novamente");
          break;

          case(error.status == 429):
            this.globals.showSnackBar(finalMessage || "Busca de ordens: limite de requisições atingido, por favor aguarde um minuto e tente novamente.");
          break;

          default:
            this.globals.showSnackBar(errorList?.[0]?.message || "Desculpe, houve um erro ao processar sua requisição, por favor tente novamente mais tarde.");
            break;
        }
      }
    });
  }

  public showOrdemEmAtendimentoDialog() {
    const data = {
      messages: ['Existe outra ordem em atendimento, por favor, aguarde a finalização.'],
      confirmText: 'Entendi',
      cancelText: 'Ver ordem'
    };

    const dialogRef = this.dialog.open(DialogComponent, {
      width: '490px',
      data: data,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result.confirm)
        this.router.navigate(["listar-ordem", this.nroProcesso.value]);
    });
  }

  public openAtualizarOrdemDialog(): void {
    const data = {
      messages: ['Ação encontrada na base de dados do Serasa.', 'Deseja atualizar esta ação?'],
      confirmText: 'Atualizar',
      cancelText: 'Voltar'
    };

    const dialogRef = this.dialog.open(DialogComponent, {
      width: '400px',
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && !result.confirm)
        this.router.navigate(['ordem']);
    });
  }

  get nroProcesso() {
    return this.form.get('nroProcesso');
  }
}
